"use client";

import * as React from "react";
import { ArrowLeft, ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const showcases = [{
  id: 1,
  title: "Hollywood Smile Dönüşümü",
  category: "Gülüş Tasarımı",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/showcase_ecommerce_render.png"
}, {
  id: 2,
  title: "Zirkonyum Kaplama Uygulaması",
  category: "Restoratif Tedavi",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/showcase_fintech_render.png"
}, {
  id: 3,
  title: "Tam Çene İmplant Tedavisi",
  category: "Dental İmplant",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/showcase_agency_render.png"
}, {
  id: 4,
  title: "Lazerle Diş Beyazlatma",
  category: "Estetik İşlem",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/showcase_health_render.png"
}, {
  id: 5,
  title: "Porselen Lamine Veneer",
  category: "Gülüş Tasarımı",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/showcase_ai_render.png"
}];
export default function DesignShowcase() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  const progress = count === 0 ? 0 : current / count * 100;
  return;
}